import api from '@/api';
import MonetaryRequest from '@/model/monetary/MonetaryRequest';
import MonetarySearchRequest from '@/model/monetary/MonetarySearchRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return Promise.resolve();
    /*   return api.base()
        .get('/monetaryTransaction/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        ); */
    },
    getAllMonetary(actions, {
      filter,
      pagination,
      sort
    }) {
      return api.base()
        .post('/monetaryTransaction/get/all',
          MonetarySearchRequest({
            ...(filter || {}),
            pagination,
            sort,
          })
        )
        .then(response => (
          {
            data: response.data.data,
            pagination: {
              page: response.data.metadata.page,
              total: response.data.metadata.total
            },
            sort: response.data.metadata.sort
          })
        );
    },

    getAllMonetaryWithdraws(actions, {
      filter,
      pagination,
      sort,
      forcedType,
      forcedStatus
    }) {

      const finalFilter = {
        ...(filter || {}),
        type: forcedType,
        status: forcedStatus
      };

      return api.base()
        .post('/monetaryTransaction/get/all',
          MonetarySearchRequest({
            filter: finalFilter,
            pagination,
            sort
          })
        )
        .then(response => ({
          data: response.data.data,
          pagination: {
            page: response.data.metadata.page,
            total: response.data.metadata.total
          },
          sort: response.data.metadata.sort
        }));
    },

    getMonetaryById({ commit }, id) {
      return api.base()
        .get('/monetaryTransaction/id/' + id)
        .then(
          response => {
            let data = { ...response.data.data };
            if(response.data.metadata != null && response.data.metadata.processorTransaction != null){
              data.processorTransaction = response.data.metadata.processorTransaction;
            }
            return data;
          }
        );
    },
    handleEvent({ commit }, { id, event }) {
      return api.base()
        .post('/monetaryTransaction/handleEvent/' + id+'/'+event)
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    delete({ commit }, { id}) {
      return api.base()
        .post('/monetaryTransaction/delete/' + id)
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateMonetary({ commit }, {
      monetary,
      id
    }) {
      return api.base()
        .post('/monetaryTransaction/update/' + id, monetary)
        .then(
          response => {
            return response.data.data;
          }
        );
    },

    // Second-level finance action (approve / cancel / comment) on an approved deposit.
    financeEvent({ commit }, { id, event, comment }) {
      return api.base()
        .post(`/monetaryTransaction/finance/${id}/${event}`, { comment: comment || '' })
        .then(
          response => response.data.data,
          err => Promise.reject(err)
        );
    },

    // Manual FTD/STD reclassification (FTD / STD / FTD_A..FTD_E / NONE) —
    // needs the FTD_STD_CHANGES permission on the backend.
    updateMonetaryFtdStatus({ commit }, { id, ftdStatus }) {
      return api.base()
        .post(`/monetaryTransaction/update/ftd-status/${id}?ftdStatus=${ftdStatus}`)
        .then(
          response => response.data.data,
          err => Promise.reject(err)
        );
    },

    // STD bulk fix (temporary tool, MONETARY_STD_BULK permission): preview of
    // clients whose deposits should be STD but aren't — {groups, clients}.
    // scope = the monetary page's filter {orgIds, buIds, userIds, range} — the
    // preview only lists clients matching it (empty scope = everything visible).
    getStdFixPreview(actions, scope) {
      return api.base()
        .post('/monetaryTransaction/std-fix/preview', scope || {})
        .then(
          response => response.data.data,
          err => Promise.reject(err)
        );
    },

    // STD bulk fix apply: mark the confirmed transaction ids as STD.
    // Returns one {id, success, error} entry per transaction.
    applyStdFix({ commit }, { ids }) {
      return api.base()
        .post('/monetaryTransaction/std-fix/apply', { ids })
        .then(
          response => response.data.data,
          err => Promise.reject(err)
        );
    },

    // Flip a transaction between REAL and FAKE ("fake approve" finance action).
    updateMonetaryRealStatus({ commit }, { id, realType }) {
      return api.base()
        .post(`/monetaryTransaction/update/real-status/${id}?realType=${realType}`)
        .then(
          response => response.data.data,
          err => Promise.reject(err)
        );
    },

    updateMonetaryDepositor({ commit }, {
      monetaryId,
      userId
    }) {
      return api.base()
        .post(`/monetaryTransaction/updateMonetaryDepositor?monetaryId=${monetaryId}&userId=${userId}`)
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    createMonetary({ commit }, { monetary }) {
      return api.base()
        .post('/monetaryTransaction/add', monetary)
        .then(
          response => {
            return response.data.data;
          }
        );
    },

    transferMonetary({ commit }, { monetary }) {
      return api.base()
        .post('/monetaryTransaction/transfer', monetary)
        .then(
          response => {
            return response.data.data;
          }
        );
    },

    exportMonetaryDataExcel(actions, { filter, pagination, sort, fields }){
      let request = {searchRequest:  { ...(filter || {}), pagination, sort }, fields };
      return api.base()
        .post('/monetaryTransaction/report/file/download', request, { responseType: 'blob' })
        .then(
          response => {
            console.log("after", response);
            const url = URL.createObjectURL(new Blob([response.data],
              { type: response.headers["content-type"] }
            ))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', response.headers["file-name"])
            document.body.appendChild(link)
            link.click()

            return response.data
          }).catch(console.error)

    },

  }

};
